import React from 'react'
import * as classes from './LoaderArticles.module.scss'

function LoaderArticles() {
    return (
        <div className={classes.Wrap}>
            <div className={classes.Left}>
                <div className={classes.Avatar} />
                <span className={classes.Date} />
            </div>

            <div className={classes.Right}>
                <div className={classes.Title}>
                    <span className={classes.TitleLine} />
                    <span className={classes.TitleLine} />
                </div>

                <div>
                    <span className={classes.DescLine} />
                    <span className={classes.DescLine} />
                    <span className={classes.DescLine} />
                    <span className={classes.DescLine} />
                    <span className={classes.DescLine} />
                    <span className={classes.DescLine} />
                    <span className={classes.DescLine} />
                </div>
            </div>
        </div>
    )
}

export default LoaderArticles
